import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { automatedRolloutsReducer } from './automated-rollouts.reducer';
import { AutomatedRolloutEffects } from './automated-rollouts.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('automatedRollouts', automatedRolloutsReducer),
    EffectsModule.forFeature([AutomatedRolloutEffects]),
  ],
  providers: [],
})
export class AutomatedRolloutsStoreModule {}
